module.exports = require("vuetify/lib/components/VBtn");